import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  DateField,
  BooleanField,
  EditButton,
  ShowButton,
  DeleteButton,
  Filter,
  SearchInput,
  SelectInput,
  TopToolbar,
  CreateButton,
  ExportButton,

  FunctionField,
  ChipField,

} from 'react-admin';

const SupplementFilter = (props: any) => (
  <Filter {...props}>
    <SearchInput source="q" alwaysOn />
    <SelectInput
      source="isActive"
      choices={[
        { id: true, name: 'Активная' },
        { id: false, name: 'Неактивная' },
      ]}
      label="Статус"
    />
  </Filter>
);

const ListActions = () => (
  <TopToolbar>
    <CreateButton />
    <ExportButton />
  </TopToolbar>
);

const PriceField = ({ record }: any) => (
  <span>${record?.price?.toFixed(2) || '0.00'}</span>
);

const EmojiField = ({ record }: any) => (
  <span style={{ fontSize: '1.5em' }}>{record?.emoji || '❓'}</span>
);

const ColorChip = ({ record }: any) => (
  <ChipField 
    record={{ value: record?.color || 'Не указан' }} 
    source="value"
    style={{ backgroundColor: record?.color || '#ccc', color: 'white' }}
  />
);

export const SupplementList = () => (
  <List
    filters={<SupplementFilter />}
    actions={<ListActions />}
    sort={{ field: 'createdAt', order: 'DESC' }}
    perPage={25}
  >
    <Datagrid>
      <TextField source="id" label="ID" />
      <EmojiField label="Эмодзи" />
      <TextField source="name" label="Название" />
      <TextField source="subtitle" label="Подзаголовок" />
      <PriceField label="Цена" />
      <ColorChip label="Цвет" />
      <TextField source="duration" label="Длительность" />
      
      {/* Преимущества */}
      <FunctionField 
        label="Преимущества" 
        render={(record: any) => record.benefits?.slice(0, 2).join(', ') || 'Нет'} 
      />
      
      {/* Целевые челленджи */}
      <FunctionField 
        label="Челленджи" 
        render={(record: any) => record.targetChallenges?.slice(0, 2).join(', ') || 'Нет'} 
      />
      
      <BooleanField source="isActive" label="Активна" />
      <DateField source="createdAt" label="Создано" />
      
      <EditButton />
      <ShowButton />
      <DeleteButton />
    </Datagrid>
  </List>
);
